var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExitTileView(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#474749"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6673 19.8891C20.0804 19.476 20.0804 18.8064 19.6673 18.3933L17.274 16L19.6673 13.6067C20.0804 13.1936 20.0804 12.524 19.6673 12.1109C19.2542 11.6978 18.5846 11.6978 18.1715 12.1109L15.7782 14.5042L13.3849 12.1109C12.9718 11.6978 12.3022 11.6978 11.8891 12.1109C11.476 12.524 11.476 13.1936 11.8891 13.6067L14.2824 16L11.8891 18.3933C11.476 18.8064 11.476 19.476 11.8891 19.8891C12.3022 20.3022 12.9718 20.3022 13.3849 19.8891L15.7782 17.4958L18.1715 19.8891C18.5846 20.3022 19.2542 20.3022 19.6673 19.8891Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitTileView);
export default __webpack_public_path__ + "static/media/exit-tile-view.6b8e6574cf9ca0c7850829401fe28788.svg";
export { ForwardRef as ReactComponent };